module.exports = "/_next/static/images/b5275c8fb5f26fded41d1a4f3c4e8200-mb-hero-xs.jpg.webp";